import { render, staticRenderFns } from "./authPermissionRule.vue?vue&type=template&id=7bd557f9"
import script from "./authPermissionRule.vue?vue&type=script&lang=js"
export * from "./authPermissionRule.vue?vue&type=script&lang=js"
import style0 from "./authPermissionRule.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports